import { createEnvelopeSource } from './create-envelope-source';

/**
 * Coupons-issued KPI source. Pure config over the standardized envelope
 * (`GET /analytics/coupons/issued`): one scalar count of promotion-grant rows
 * created in the period (promotions belonging to no campaign, or the
 * campaign scope when given), plus a `businessUnit` and a
 * `province` breakdown of it, and `couponRedemptionRate`, the share of those
 * grants already redeemed. All mapping and fetching lives in
 * `createEnvelopeSource`.
 *
 * The RPP-only subset is its own source (`coupon-issued-rpp`), not a second
 * metric here. The two count different populations off different tables and
 * attribute province from different records (the app account vs the RPP
 * registration), so the backend serves them as two KPIs; a card that wants both
 * composes two sources rather than reading two metrics that only look like a
 * pair. `couponsIssuedRpp` also keeps coupons released unredeemed at expiry,
 * which this metric excludes: the two never sum and neither nests in the
 * other.
 *
 * Total-only: the endpoint declares `capabilities.daily=false`, so there is no
 * `line` form here (unlike coupon-activation, which does serve a daily series).
 */
export const couponIssuedSource = createEnvelopeSource({
    label: 'Coupons issued',
    endpoint: 'analytics/coupons/issued',
    metrics: [
        { id: 'couponsIssued', label: 'Coupons issued', type: 'scalar' },
        { id: 'couponRedemptionRate', label: 'Redemption rate', type: 'ratio' },
    ],
    forms: ['number', 'rate', 'bars', 'pie'],
    regionGrain: 'province',
});
